import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const IntercomHash = z.object({
  hash: z.string()
});

export type IntercomHash = z.infer<typeof IntercomHash>;

export default c.router({
  getHash: {
    method: 'GET',
    path: '/intercoms/hashes',
    responses: {
      200: IntercomHash
    }
  }
});
